var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-limited-subscription-summary"},[_c('b-card',{attrs:{"no-body":""}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n            "+_vm._s(_vm.caption)+"\n            "),_c('div',{staticClass:"card-header-actions pull-right"},[_c('b-button',{attrs:{"type":"button","variant":"info"},on:{"click":_vm.open}},[_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Sélection produit'))+"\n                ")])],1)]),_c('b-card-body',[_c('ProductSummary',{ref:"productSummary",attrs:{"fieldRefs":_vm.fieldRefs,"evalFromQuantity":false},on:{"updateTotal":_vm.updateTotal},model:{value:(_vm.dataProducts),callback:function ($$v) {_vm.dataProducts=$$v},expression:"dataProducts"}}),(_vm.required && !_vm.chkState(_vm.id))?_c('div',{staticClass:"invalid-feedback",staticStyle:{"display":"block"}},[(_vm.invalidFeedbackMessage !== '')?_c('span',[_vm._v(_vm._s(_vm.invalidFeedbackMessage))]):_vm._e(),(_vm.invalidFeedbackMessage === '')?_c('span',[_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Vous devez sélectionner un produit.')))]):_vm._e()]):_vm._e(),_c('ModalInstanceSelector',{ref:"modalInstanceSelector",attrs:{"caption":_vm.Core.Definition.getDefinition('Liste des produits'),"root":"/product/list","quantityStep":"bookingLimit","multiple":false,"searchFormStructure":{
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'id'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'title'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'id',
                                type: 'number',
                                label: _vm.Core.Definition.getDefinition('ID'),
                                value: ''
                            },
                            {
                                id: 'title',
                                type: 'text',
                                label: _vm.Core.Definition.getDefinition('Titre'),
                                value: ''
                            }
                        ]
                    },"searchArgs":[
                        {
                            key: 'type',
                            value: _vm.Core.Product.typeLimitedSubscription
                        }
                    ],"options":{
                            pagination: true,
                            header: true,
                            responsive: false,
                            striped: true,
                            headerStyle: '1',
                            emptyText: _vm.Core.Definition.getDefinition('Aucun produit limité à afficher'),
                            borderVariant: 'white',
                            noBody: true
                     },"columns":[
                            {
                                label: _vm.Core.Definition.getDefinition('#'),
                                key: 'id',
                                sortable: true
                            },
                            {
                                label: _vm.Core.Definition.getDefinition('Titre'),
                                key: 'title',
                                sortable: true
                            },
                            {
                                label: _vm.Core.Definition.getDefinition('Prix régulier'),
                                key: 'Readable.regularPrice',
                                type: 'text',
                                sortable: true
                            }
                     ]},model:{value:(_vm.dataProducts),callback:function ($$v) {_vm.dataProducts=$$v},expression:"dataProducts"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }